const state = {
  nama: "ilham",
  dataDashboard: {},
  dataOtp: {},
  dataLayanan: {},
};

export default state;
